const QuestionAnswerState = {
  questionAnswers: {},
  destroyDialogIsOpen: false,
  selectedRow: null,
  action: null,
};

export default QuestionAnswerState;
